import React, {Component} from 'react';
import styled from 'styled-components';
import {connect} from 'react-redux'
import {submit,} from "../../actions/calculator";

class ConfirmationPopup extends Component {
    confirm() {
        let prefix = '';
        this.props.history.push(`${prefix}/`);
    }

    componentDidMount() {

        const {form, entities} = this.props;
        const pkg = form.package && entities.packages[form.package];

        if(!pkg) {
            // this.props.history.push('/');
        }
    }
    render() {
        const {className, form, entities, onSubmit} = this.props;

        return <div className={className}>
            <div className='popup'>
                <div className='popup_inner'>
                    <div className='wrapper'>
                        {/* <button onClick={this.props.closePopup}>close me</button> */}
                        <div>{this.props.text}</div>
                    </div>
                </div>
            </div>
        </div>
    }
}

const mapStateToProps = (state, ownProps) => {
    return {
        ...ownProps,
        ...state.calculator,
        context: state.context,
        calculator: state.calculator,
    };
};

const mapDispatchToProps = dispatch => {
    return {
        async onSubmit() {
            let prefix = '';
            const result = await dispatch(submit());
            console.log('onSubmit:result: ', result);
            this.history.push(`${prefix}/confirmation`);
        }
    }
};

const ConnectedConfirmationPopup = connect(
    mapStateToProps,
    mapDispatchToProps
)(ConfirmationPopup);

let StyledConfirmationPopup = styled(ConnectedConfirmationPopup)`
width: 100%;
/* popup */
.app {
  margin: 0;
  padding: 0;
  position: relative;
  width: 100%;
}
.popup {
  position: fixed;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  margin: auto;
  background-color: rgba(0,0,0, 0.5);
  overflow-x: hidden;
  overflow-y: auto;
  z-index: 11;
  padding: 20px;
}
.popup_inner {
  position: absolute;
  top: 45%;
  left: 0;
  right: 0;
  bottom: 0;
  color: #333;
}
.wrapper{
    max-width: 700px;
    margin: 0 auto; 
    padding: 20px;
    @media (min-width:321px) and (max-width:480px) {
        width:95%;
    }
    @media (min-width:481px) and (max-width:567px) {
        width:90%;
    }
    @media (min-width:568px) and (max-width:767px){
        width:80%;
    }
    @media (min-width: 768px) and (max-width: 960px) {
        width: 80%;
    }
    @media (min-width: 961px) and (max-width: 992px) {
        width: 80%;
    }
    @media (min-width: 993px){
        width: 650px;
    }
}
.installWrap{
    margin-top: 13px;
    cursor: pointer;
}
.popbtn {
    background: rgb(238, 240, 244);
    border: 1px solid #ced4da;
    color: #212529;
    padding: 0.35rem 1rem 0.25rem;
    margin-right: 1rem;
}
.btn-primary:focus, .btn-primary.focus {
    box-shadow: none;
}
.confirmTxt, .carmodelTitle {
    display: block;
    max-width: 700px;
    height: auto;
    margin: 0 auto;
    text-align: center;
    font-size: 1.2rem;
    line-height: 1;
    padding: 25px 10px;
    border: 1px solid #ced4da;
    background: #fff;
}
.carmodelTitle {
    font-size: 1.9rem;
    font-family: CorporateACon, Helvetica, sans-serif;
    margin: 10px auto;
}
.vehicleWrap {
    min-height: 450px;
    overflow-y: auto;
    margin-right: 0px;
    margin: 0 auto;
}
.configurator__model_image {
  display: block;
  max-width: 100%;
  height: auto;
  margin: 0 auto;
}

.configurator__model-dropdown-container {

    max-width: 450px;
    margin: 0 auto;
    
    text-align: center;
    display: block;
    height: auto;
    padding: 12px 12px;
    
    @media(min-width: 450px) {
      width: 450px;
    }
    
    @media(max-width: 450px) {
      width: 100%;
    }
}

.installment-bar {

    height: 82.5px;
    padding-top: 12px;
    background-color: grey;
    z-index: 10;
    bottom: 0px;
    width: 100%;
    left: 0px;
    text-align: center;
  
  &, &__padding {
    width: 100%;
    height: 82.5px;
  }
  
  &__padding {
    margin-top: 20px;
  }
}
.instalment {
    &__amount-value {
      font-size: 25px;
      color: white;
      font-weight: lighter;
      color: #ddd;  
    }
    
    &__amount {
      display: inline-block;
      vertical-align: middle;
    }
  
    &__arrow {
      display: inline-block;
      vertical-align: middle;
      
      height: 25px;
      width: auto;
      
      margin: 0 5px;
    }
  
    &__month {
      font-size: 16px;
      color: #eee;
      font-weight: 100;
    }
  
    &__check-eligibility {
      font-size: 12px;
      color: #ddd;
      font-weight: 100;
      text-align: right;
    }
  }
`;

export default StyledConfirmationPopup


// WEBPACK FOOTER //
// ./src/components/configurator/ConfirmationPopup.js